import { createBreakpoints } from 'styled-breakpoints'
import styled from 'styled-components'

// custom breakpoints for pages in the swa
export const promoBreakpoints = { max: 1201 }
export const { above, below } = createBreakpoints(promoBreakpoints)

const PromoLayout = styled.div`
  ${above(promoBreakpoints.max)} {
    margin-left: auto;
    margin-right: auto;
    padding: 0;
  }
`

export default PromoLayout
